import { FieldConfig } from "../../components/FormBuilder"; 
export const vehicleTypeOptions = [
  "Two_wheeler",
  "Auto",
  "Car",
  "Truck",
  "Bus",
  "Tractor",
  "Commercial",
  "Other",
]; 

export const fuelTypeOptions = ["Petrol", "Diesel", "Electric", "Hybrid", "CNG", "LPG"];

export const currentStatusOptions = ["Active", "Sold", "Hypothecated", "Closed"];

export const vehicleFormFields: FieldConfig[] = [
  // { name: "owner_id", label: "Owner (Profile ID)", type: "text", required: true, placeholder: "Enter owner profile id" },
  { name: "vehicle_type", label: "Vehicle Type", type: "chips", required: true, options: vehicleTypeOptions },
  { name: "manufacturer", label: "Manufacturer", type: "text", required: true , placeholder: "Enter manufacturer name" },
  { name: "model", label: "Model", type: "text", required: true , placeholder: "Enter model name" },
  { name: "variant", label: "Variant", type: "text", required: false , placeholder: "Enter variant" },
  { name: "year_of_manufacture", label: "Year of Manufacture", type: "number", required: false, pattern: "^[0-9]{4}$", errorMessage: "Enter a valid 4 digit year" ,placeholder: "Enter year of manufacture"},
  { name: "registration_number", label: "Registration Number", type: "text", required: true, placeholder: "Enter registration number" },
  { name: "chassis_number", label: "Chassis Number", type: "text", required: true, placeholder: "Enter chassis number" },
  { name: "engine_number", label: "Engine Number", type: "text", required: true, placeholder: "Enter engine number" },
  { name: "fuel_type", label: "Fuel Type", type: "chips", required: false, options: fuelTypeOptions },
  { name: "vehicle_color", label: "Vehicle Color", type: "text", required: false, placeholder: "Enter vehicle color" },
  { name: "seating_capacity", label: "Seating Capacity", type: "number", required: false, minLength: 1 ,placeholder: "Enter seating capacity"},
  { name: "purchase_date", label: "Purchase Date", type: "date", required: false , placeholder: "Select purchase date"},
  { name: "insurance_expiry", label: "Insurance Expiry", type: "date", required: false , placeholder: "Select insurance expiry date"},
  { name: "hypothecated_to", label: "Hypothecated To", type: "text", required: false , placeholder: "Enter hypothecated to"},
  { name: "current_status", label: "Current Status", type: "chips", required: false, options: currentStatusOptions },
];
